import React from 'react';
import { useTranslation } from 'react-i18next';
import { toOrdinal } from '../../../../helpers/ordinal';

/**
 * DisplayMecanism
 * Props:
 *   mecanism: {
 *     type: string,
 *     unit: string,
 *     unitCondition?: number,
 *     reduction?: number
 *   }
 */
export default function DisplayMecanism({ mecanism }) {
  const { t, i18n } = useTranslation();

  if (!mecanism) return <span>{t('promotion_campaign.mecanism.none')}</span>;

  const { type, unit, unitCondition, reduction } = mecanism;
  const unitLabel = unit === 'PERCENT' ? '%' : '';

  let description;

  switch (type) {
    case 'PRICE_DISCOUNT': {
      const nth = unitCondition + 1;
      const hasCondition = unitCondition && unitCondition > 1;
      description = t(
        hasCondition
          ? 'promotion_campaign.mecanism.PRICE_DISCOUNT_nth'
          : 'promotion_campaign.mecanism.PRICE_DISCOUNT',
        { reduction, unit: unitLabel, ordinal: toOrdinal(nth, i18n.language) }
      );
      break;
    }
    case 'BUY_X_GET_Y':
      description = t('promotion_campaign.mecanism.BUY_X_GET_Y', { unitCondition, reduction });
      break;
    case 'BUY_X_SAVE_Y':
      description = t('promotion_campaign.mecanism.BUY_X_SAVE_Y', { unitCondition, reduction, unit: unitLabel });
      break;
    case 'FLAT':
      description = t('promotion_campaign.mecanism.FLAT', { reduction });
      break;
    default:
      description = `${type} (${unit}${unitCondition ? ', ' + unitCondition : ''}${reduction ? ', réduction : ' + reduction : ''})`;
  }

  return <span>{description}</span>;
}
